import { CheckBox, Text, TextTag } from "@/ui/core";
import { Box, HStack, VStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface CheckBoxFieldProps extends ViewWithTestID {
  isChecked?: boolean;
  isDisabled?: boolean;
  leftText?: string;
  onChange: (value: boolean) => void;
  rightText?: string;
  subLabel?: string;
}

const CheckBoxField = ({
  isChecked,
  isDisabled,
  leftText,
  onChange,
  rightText,
  subLabel,
  testID,
}: CheckBoxFieldProps) => {
  return (
    <HStack gap={8}>
      <CheckBox
        isChecked={isChecked}
        isDisabled={isDisabled}
        onChange={onChange}
        testID={testID}
      />
      <VStack flexGrow={1} gap={8}>
        <HStack alignItems="center" gap={8} justifyContent="space-between">
          {leftText && (
            <Text testID={joinTestIDs(testID, "label")} variant="bodyMedium">
              {leftText}
            </Text>
          )}
          {rightText && (
            <Box>
              <TextTag
                testID={joinTestIDs(testID, "tag")}
                text={rightText}
                variant="highlight"
              />
            </Box>
          )}
        </HStack>
        {subLabel && (
          <Text
            color={ColorToken.NeutralSecondary}
            testID={joinTestIDs(testID, "caption")}
            variant="caption"
          >
            {subLabel}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export type { CheckBoxFieldProps };
export default CheckBoxField;
